import { RANGE_SLIDER_MAX_VALUE, RANGE_SLIDER_MIN_VALUE, RangeSliderButtonType, RangeSliderSlideValue } from './range-slider';

/**
 * Util Service, das im RangeSliderComponent benutz wird.
 */
export class RangeSliderUtils {
    validation = {
        from: RangeSliderUtils.validateValueFrom,
        to: RangeSliderUtils.validateValueTo
    };

    /**
     * Berechnet die Weglänge der Leuchtmarke als Prozentsatz.
     * Die Berechnung erfolgt in Bezug auf den Schiebereglerbereich gemacht.
     * Fürt eine Validierung des Wertes aus, ob den Wert im Schiebereglerbereich und "from" nicht größer als "to" ist.
     */
    positionToValue(buttonType: RangeSliderButtonType, slideValue: RangeSliderSlideValue, parentRect: ClientRect,
                    oppositeValue: number, initialValue: number) {
        const distance = slideValue.current - slideValue.initial;
        const distanceInPercent = distance / (parentRect.right - parentRect.left) * 100;
        const newValue = initialValue + distanceInPercent;

        if (!this.validation[buttonType](newValue, oppositeValue)) {
            return getExtreme(newValue);
        }

        return newValue;

        function getExtreme(value) {
            return buttonType === 'from' ? getExtremeFrom(value) : getExtremeTo(value);
        }

        function getExtremeFrom(value) {
            const min = RANGE_SLIDER_MIN_VALUE;
            const max = oppositeValue;
            return value >= max ? max : min;
        }

        function getExtremeTo(value) {
            const min = oppositeValue;
            return value <= min ? min : RANGE_SLIDER_MAX_VALUE;
        }
    }

    static validateValueFrom(value, oppositeValue): boolean {
        return value >= RANGE_SLIDER_MIN_VALUE && value <= RANGE_SLIDER_MAX_VALUE && value <= oppositeValue;
    }

    static validateValueTo(value, oppositeValue): boolean {
        return value >= RANGE_SLIDER_MIN_VALUE && value <= RANGE_SLIDER_MAX_VALUE && value >= oppositeValue;
    }
}
